import { ICONS } from "semantic-ui-react/dist/commonjs/lib/SUI";

/* Semantic UI React's own canonical icon-name list (953 deduped names) —
   used to drive icon-picker dropdowns so every real Semantic icon is
   selectable, not just a hand-typed subset. */
export const ICON_OPTIONS = [...ICONS]
  .sort((a, b) => a.localeCompare(b))
  .map((name) => ({ key: name, value: name, text: name }));
